/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faBed } from '@fortawesome/free-solid-svg-icons/faBed'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function BedroomsField (props: FormNumberFieldProps) {
  const { name = 'bedrooms', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'bedrooms',
        defaultMessage: 'Chambres'
      })}
      name={name}
      parser={parseNumber}
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faBed}
        />
      )}
      {...others}
    />
  )
}

export default BedroomsField
